// @flow

import radio from 'app/get-help/components/blocks/Radio';
import {
  createBilling,
  createEnterprise,
  createDiscounts,
  createOther,
  createPlan,
  createTeams,
  createSettings,
  createDelete,
  createIssues,
  createTrial,
  createTask,
} from 'app/get-help/content/nodes/common/account';
import { ZENDESK_CUSTOM_FIELD_IDS } from 'app/get-help/constants';


const isLoggedIn = true;

const account = radio({
  id: 'account',
  label: 'What can we help you with?',
  zendeskCustomFieldId: ZENDESK_CUSTOM_FIELD_IDS.ACCOUNTS_WHAT_CAN_WE_HELP_WITH,
  items: [
    createTask(isLoggedIn),
    createTrial(isLoggedIn),
    createPlan(isLoggedIn),
    createBilling(isLoggedIn),
    createDiscounts(isLoggedIn),
    createIssues(isLoggedIn),
    createSettings(isLoggedIn),
    createTeams(isLoggedIn),
    createEnterprise(isLoggedIn),
    createDelete(isLoggedIn),
    createOther(isLoggedIn),
  ],
});

export default account;
